import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import * as FileSaver from 'file-saver';
import { MatDialog } from '@angular/material/dialog';
import { CoreService } from '../../core/header/core.service';
import { CoreComponent } from '../../core/header/core.component';
import { ocrHistoryModel } from './ocrHistory.model';
import { ocrHistoryConst } from './const';
import { FilesService } from '../file/files.service';
import { OcrHistoryService } from './ocrHistory.service';

@Component({
    selector: 'convfact-ocrHistory',
    templateUrl: './ocrHistory.component.html',
    styleUrls: ['./ocrHistory.component.css'],
    standalone: false
})

export class OcrHistoryComponent implements OnInit {

  constructor(
    private router: Router,
    private ocrHistoryService: OcrHistoryService,
    private coreService: CoreService,
    public dialog: MatDialog,
    private route: ActivatedRoute,
    public snackBar: MatSnackBar,
    private core: CoreComponent,
    public fileService: FilesService
  ) { }

  dataSource: ocrHistoryModel[] = [];

  pagesUsed = 0;
  pagesTotal = 0;
  creditPages = 0;
  ocrWindowEnd: Date = null;

  currentFiscalyear: number = this.core.yearSelected;
  currentActivityUid: string = this.core.activitySelected;
  sii: boolean;
  ready = false;
  empty = false;
  show = false;

  headerTable: any[] = ocrHistoryConst.headerTable;

  displayInfo(response: string): void {
    const options = new MatSnackBarConfig();
    const self = this;
    options.duration = 10500;
    this.snackBar.open(response, '', options);
  }

  goInvoice(uid: string) {
    const invoiceUid = this.dataSource.find(x => x.uid === uid).invoiceUid;
    this.router.navigate(['/expense/edit/' + invoiceUid]);
  }

  goFile(uid: string) {
    this.show = true;
    const file = this.dataSource.find(x => x.uid === uid);
    const fileUid = file.fileUid;
    this.fileService.getFile(fileUid).then(response => {
      if (response.type === 'PDF') {
        this.fileService.returnFilePDF(fileUid).then(response => {
          FileSaver.saveAs(response,  file.fileName + '.pdf');
          this.show = false;
        });
      }
      if (response.type === 'Image') {
        this.fileService.returnFileImage(fileUid).then(response => {
          FileSaver.saveAs(response, file.fileName + '.png');
          this.show = false;
        });
      }
    })
  }

  ngOnInit() {
    this.dataSource = [];
    this.currentActivityUid = this.core.activitySelected;
    this.currentFiscalyear = this.core.yearSelected;
    this.coreService.setName('Histórico OCR');
    this.ocrHistoryService.getList().then(data => {
      this.dataSource = data;
      this.ocrHistoryService.getSubscriptionParams().then(data2 => {
        this.pagesUsed = data2.pagesUsed;
        this.pagesTotal = data2.pagesTotal;
        this.creditPages = data2.creditPages || 0;
        this.ocrWindowEnd = data2.ocrWindowEnd || null;
        if (this.dataSource.length === 0) {
          this.empty = true;
        } else {
          this.empty = false;
        }
        this.ready = true;
      });
    });
  }
  public trackByIndex(i: number) { return i; }

}
